import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import Vuelidate from 'vuelidate'
import axios from 'axios'
// adding bootstrap framework to the app
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
// adding custom css to the app
import './assets/css/styles.css'
import './assets/css/extra-styles-bootstrap.css'
// adding fontawesome library to the app
import { library } from '@fortawesome/fontawesome-svg-core'
// making available some icons to be used in the app
import { faEnvelope, faLock, faUser, faSmile, faPhone, faMapMarkedAlt, faAt, faDollarSign, faHandHoldingUsd,
  faCalendarAlt, faGlobe, faMapMarkerAlt, faSignOutAlt, faEye, faPlus} from '@fortawesome/free-solid-svg-icons'
// adding FontAwesomeIcon component into the app
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
// adding icons to be used in the library
library.add(faEnvelope, faLock, faUser, faSmile, faPhone, faMapMarkedAlt, faAt, faDollarSign, faHandHoldingUsd,
  faCalendarAlt, faGlobe, faMapMarkerAlt, faSignOutAlt, faEye, faPlus)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(Vuelidate)

Vue.config.productionTip = false
// Defining some axios constant parameters that won't change in any request
axios.defaults.baseURL = 'http://127.0.0.1:8000/'
axios.defaults.headers.common = {
  'Access-Control-Allow-Origin': '*',
  'Content-Type': 'application/json'
}
/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js